module.exports = __webpack_public_path__ + "static/15-478bb1337e1ccdb81ca1443c8a423bb3.jpg";